import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Sidebar from "../components/Sidebar";
import LoaderUI from "../components/common/loader/index";
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import Header from "../components/Header/Header";
import Footer from "../components/Footer";
import { roleItems, timeout } from "../utils/constants";
import { logout, unauthorized, saveTempData } from "../context/actions/user";
import { useIdleTimer } from 'react-idle-timer';
import { tempAction, validationAction } from "../context/actions/tempAction"

import { pdfDataSave, saveValidateJsonData } from "../context/actions/document";
const PrivateLayout = ({ children, className, allowedRoles }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	let isLoading = useSelector(state => state.general.loading);
	let loggedIn = useSelector(state => state.user.loggedIn);
	let role = useSelector(state => state?.user?.user?.role);
	const temporaryData = useSelector((state) => state?.tempReducer?.data);
	const validation = useSelector((state) => state?.tempReducer?.validaton);
	const activeTab = useSelector((state) => state?.document?.isOn)
	const roleIndex = roleItems?.indexOf(role);
	const view = useSelector((state) => state.document.view)

	if (!loggedIn) history.push('/login');
	else if (roleIndex === 1 && ( location.pathname.includes("location") || location.pathname.includes("operator"))) {
		dispatch(unauthorized())
		history.push('/dashboard');
	}

	// if (!location.pathname.includes("documentDetail")) {
	// 	window.socket.emit(`remove`, { data: { user: user?._id } });
	// 	dispatch({ type: "SET_VIEW_RECORD", data: false })
	// }


	const onIdle = () => {
		if (Object.keys(temporaryData).length !== 0 || Object.keys(validation).length !== 0) {
			if (activeTab == "C") {
				for (let key in temporaryData.json2) {
					let changesViaVersion = temporaryData.json2[key].changesViaVersion
					let keys = Object.keys(changesViaVersion).filter(key => changesViaVersion[key] === temporaryData.version);
					for (let i of keys) {
						if (temporaryData.json2[key]?.isAccepted)
							delete temporaryData.json2[key]?.isAccepted[i]
						if (temporaryData.json2[key]?.acceptedAt)
							delete temporaryData.json2[key]?.acceptedAt[i]
					}

				}
				dispatch(pdfDataSave({
					mode: "autosave_C",
					xmlMeta: temporaryData.xmlMeta2, base_dir: temporaryData.folder.base_dir, name: temporaryData.name,
					jsonMeta: temporaryData.json2, docId: temporaryData._id, location: temporaryData.location,
					version: temporaryData.version, pageNumber: temporaryData.pageNumber, folder_id: temporaryData.folder_id,
					acceptedItms: 0, // this is used for showing c green
					is_correct:temporaryData?.is_correct,
					is_verified:temporaryData?.is_verified,
					validation_blob: temporaryData?.validation_blob, currentVersion: temporaryData.currentVersion,
				}, (result) => {
					if (!result || result) {
						dispatch(tempAction({}))
						dispatch(logout(() => {
							history.push("/")
						}));
					}
				}
				))

			}
			else
				dispatch(saveValidateJsonData({
					mode: "autosave_V",
					organization: validation.organization,
					docId: validation.docId,
					json: validation.json,
					version: validation.version,
					sellerLoanNumber: validation.sellerLoanNumber,
					isChangeSellerLoanNumber: validation.isChangeSellerLoanNumber
				}, ((result) => {
					//console.log('result', result)
					if (!result || result) {
						//	console.log('result', result);
						dispatch(validationAction({}))
						dispatch(logout(() => {
							history.push("/")
						}));

					}

				})))

		}
		else {
			dispatch(logout(() => {
				history.push("/")
			}));
		}

	}
	useIdleTimer({
		timeout,
		onIdle,
		crossTab : true
	})
	return (
		<>
			{/* {console.log('temporaryData  validation ,--------->',temporaryData,validation)} */}
			{<div className="main-wrapper d-flex flex-column flex-fill overflow-auto">
				<Header className={className} />
				<div className="d-flex flex-column flex-fill overflow-auto">
					<div className="inner-wrapper d-flex flex-fill overflow-auto" id="mainInner">
						<Sidebar />
						<div className="right-wrapper d-flex flex-column flex-fill overflow-auto">
							{isLoading && <LoaderUI
								loader={isLoading}
								overlay={true}
								overlayRadius='rounded-0'
								size=""
							/>}
							{children}
						</div>
					</div>
					<Footer className="mt-auto text-center" />
				</div>
			</div>}
		</>
	)
};

PrivateLayout.propTypes = {
	/**
	 * Whether to display the navbar, or not.
	 */
	noNavbar: PropTypes.bool,
	/**
	 * Whether to display the footer, or not.
	 */
	noFooter: PropTypes.bool
};

PrivateLayout.defaultProps = {
	noNavbar: false,
	noFooter: false
};

export default PrivateLayout;
